import { useContext, useEffect, useState } from 'react';

import { context as stateContext } from '../view/context/state';

export const useGetOrganizationIdFromState = (orgId?: string | null) => {
  const { lastAccessedOrganization } = useContext(stateContext);

  const [organizationId, setOrganizationId] = useState('');

  useEffect(() => {
    if (orgId && orgId !== lastAccessedOrganization?.id) {
      setOrganizationId(orgId);
    } else if (lastAccessedOrganization != null) {
      setOrganizationId(lastAccessedOrganization.id);
    }
  }, [orgId, setOrganizationId, lastAccessedOrganization]);

  return { organizationId };
};
